import React, { useEffect, useState } from 'react';
import { Switch, Route, useParams, useLocation, useHistory } from 'react-router-dom';
import FVInitialAccess from '../public/FVInitialAccess';
import Styled from '../styles/public/FerramentaVideoPublic.styled';
import FVHeader from '../components/public/FVHeader';
import { useFerramentaVideo } from '../hooks/public/useFerramentaVideo';
import FVNotFound from '../public/FVNotFound';
import FVHome from '../public/FVHome';
import useFetch from 'hooks/useFetch';
import { CategoriaUsersPE } from 'core/http/service/acessosExclusivos/CategoriaUsersPE.service';
import { IFVRole } from '../interfaces/FVRole.interface';
import keycloak from 'core/config/keycloak';
import FVPacote from '../public/FVPacote';
import FVContents from '../public/FVContents';
import ContactContainer from 'pages/home/components/contact/ContactContainer';
import Cookies from 'js-cookie';

const serviceCategoria = new CategoriaUsersPE();

const FVRouterPublic = () => {
    const history = useHistory();
    const { urlFerramenta } = useParams<{ urlFerramenta: string }>();
    const location = useLocation();
    //Pegar o redirect na url caso tenha
    const redirectUrl = new URLSearchParams(window.location.search).get('redirect');

    const { listFerramenta } = useFerramentaVideo(urlFerramenta);
    const [ferramentaRoles, setFerramentaRoles] = useState<IFVRole[] | null>(null);
    const [loadingPage, setLoadingPage] = useState<boolean>(true);
    const [redirect, setRedirect] = useState<string | null>(redirectUrl);
    const [hiddenButtonBack, setHiddenButtonBack] = useState<boolean>(false);

    const [menuActive, setMenuActive] = React.useState<string | undefined>(() => Cookies.get('menuTypePackage'));

    useEffect(() => {
        // Verifica se está na rota /videos/:urlFerramenta
        const match = location.pathname === `/videos/${urlFerramenta}`;
        setHiddenButtonBack(match);
    }, [location.pathname, urlFerramenta]);

    const handleRedirect = () => {
        history.replace(redirect ?? '/');
    };

    useFetch(async () => {
        if (listFerramenta.data && keycloak.authenticated) {
            const { data } = await serviceCategoria.listMyCategories();

            if (listFerramenta.data?.roles) {
                const roleDefault = listFerramenta.data.roles.find((role: any) => role.default);

                if (!Array.isArray(data)) {
                    setFerramentaRoles(roleDefault ? [roleDefault] : []);
                    setLoadingPage(false);

                    return;
                }

                const idsCategoriasUser = data.map((c: any) => c.codigoCategoria);

                let rolesCopy = [...listFerramenta.data.roles];

                let roles = rolesCopy.map(role => {
                    return role.categorias.map((dados: any) => {
                        if (dados) {
                            if (idsCategoriasUser.includes(dados.id)) {
                                return role;
                            }
                            return null;
                        }
                    });
                });

                // Flatten and filter to get IFVRole[]
                const filteredRoles: IFVRole[] = roles.flat().filter((role): role is IFVRole => role !== null && role !== undefined);

                if (filteredRoles.length === 0) {
                    // fallback to defaultRole(s)
                    setFerramentaRoles(listFerramenta.data.roles.filter((role: any) => role.default));
                } else {
                    setFerramentaRoles(filteredRoles);
                }
            }
        } else if (listFerramenta.data && listFerramenta.data.roles) {
            setFerramentaRoles(listFerramenta.data.roles.filter((role: any) => role.default));
        }

        setLoadingPage(false);
    }, [listFerramenta.data]);

    useEffect(() => {
        if (redirectUrl) {
            setRedirect(redirectUrl);
        }
    }, [redirectUrl]);

    if (listFerramenta.isLoading || loadingPage) {
        return (
            <Styled.Global.Container style={{ justifyContent: 'center', alignItems: 'center' }}>
                <div className="loaderConteudo" style={{ width: '100px' }} />
            </Styled.Global.Container>
        );
    }

    if (!listFerramenta.data) {
        return (
            <Styled.Global.Container>
                <FVNotFound />
            </Styled.Global.Container>
        );
    }

    return (
        <Styled.Global.Container>
            <FVHeader buttonBack={hiddenButtonBack} onClickBack={handleRedirect} />
            <Switch>
                <Route
                    exact
                    path="/videos/:urlFerramenta"
                    render={props => (
                        <FVInitialAccess {...props} listFerramenta={listFerramenta} roles={ferramentaRoles} handleRedirect={handleRedirect} />
                    )}
                />
                <Route
                    exact
                    path="/videos/:urlFerramenta/home"
                    render={props => (
                        <FVHome {...props} listFerramenta={listFerramenta} handleRedirect={handleRedirect} setMenuActive={setMenuActive} />
                    )}
                />
                <Route
                    exact
                    path="/videos/:urlFerramenta/:urlPacote"
                    render={props => (
                        <FVPacote {...props} listFerramenta={listFerramenta} handleRedirect={handleRedirect} setMenuActive={setMenuActive} />
                    )}
                />
                <Route
                    exact
                    path="/videos/:urlFerramenta/:urlPacote/:urlUnidade/conteudos"
                    render={props => (
                        <FVContents
                            {...props}
                            listFerramenta={listFerramenta}
                            handleRedirect={handleRedirect}
                            setMenuActive={setMenuActive}
                            menuActive={menuActive}
                            roles={ferramentaRoles}
                        />
                    )}
                />
                <Route exact path="/videos/not-found" component={FVNotFound} />
                <Styled.Global.Content>{/* <Route path="/public/another" component={""} /> */}</Styled.Global.Content>
            </Switch>
            {!hiddenButtonBack && <ContactContainer />}
        </Styled.Global.Container>
    );
};

export default FVRouterPublic;
